/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
// material
import { ConfigToggle } from 'material/expandablesection/v2';
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
import EmojiPreview from 'material/emojipreview/emojipreview';
// styles
import injectSheet from 'react-jss'
import styles from './reactioncounts_styles'


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: GENERAL SECTION : REACTION COUNTS ~~~~~~~~~~ ========== */
const ReactionCounts = injectSheet(styles)((props) => {

  const { enableCombinedReactionCount, enableIndividualReactionCount, onChange } = props

  return (
    <Space gap={48} justifyContent={'space-between'} klass={`reactioncounts ${props.classes.reactioncounts}`} > 
      <SectionGroupV2 
        indented={true} 
        title={'Reaction counts'} 
        description={''}
        rowGap={16} 
        direction={'column'}
      >
        <ConfigToggle 
          title={'Enable combined emoji reaction count total'}
          checked={enableCombinedReactionCount}
          onChange={val => onChange({ enableCombinedReactionCount: val})}
        />
        <ConfigToggle 
          title={'Enable individual emoji reaction count totals'}
          checked={enableIndividualReactionCount}
          onChange={val => onChange({ enableIndividualReactionCount: val})}
        />
      </SectionGroupV2>
      <PreviewConfig>
        <EmojiPreview showEmojiReactionCount={enableIndividualReactionCount} emojiReactionTotal={enableCombinedReactionCount ? '4.3k' : null}  />
      </PreviewConfig>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ReactionCounts;